<nb-card>
    <nb-card-body>
        <nb-tabset>
            <nb-tab
                [nbSpinner]="!autorizzazione_distretti"
                nbSpinnerMessage=""
                tabTitle="Aziende sanitarie"
            >
                <div class="row">
                    <h6>Azienda sanitaria titolare dei dati</h6>
                    <nb-list
                        class="container m-0 p-0"
                        *ngIf="aziende_titolare_dati && aziende_titolare_dati.length > 0"
                    >
                        <nb-list-item class="px-0">
                            {{ aziende_titolare_dati[0]?.nome }}
                        </nb-list-item>
                    </nb-list>
                    <nb-list class="container m-0 p-0">
                        <nb-list-item
                            class="px-0"
                            *ngIf="!aziende_titolare_dati?.length"
                        >
                            nessun'azienda
                        </nb-list-item>
                    </nb-list>

                    <h6 class="mt-3">Altre aziende autorizzate</h6>
                    <nb-list
                        class="container m-0 p-0"
                        *ngIf="aziende_titolare_dati && aziende_titolare_dati.length > 1"
                    >
                        <nb-list-item
                            class="px-0"
                            *ngFor="let azienda of aziende_titolare_dati | slice:1"
                        >
                            {{ azienda.nome }}
                        </nb-list-item>
                    </nb-list>
                    <nb-list class="container m-0 p-0">
                        <nb-list-item
                            class="px-0"
                            *ngIf="aziende_titolare_dati?.length < 2"
                        >
                            nessun'azienda
                        </nb-list-item>
                    </nb-list>
                </div>
            </nb-tab>

            <nb-tab
                [nbSpinner]="!autorizzazione_distretti"
                nbSpinnerMessage=""
                tabTitle="Distretti"
            >
                <div class="row">
                    <nb-accordion class="col-md-6">
                        <nb-accordion-item
                            expanded
                            *ngIf="associazione_distretto_gravidanza"
                        >
                            <nb-accordion-item-header>
                                Distretto gravidanza
                            </nb-accordion-item-header>
                            <nb-accordion-item-body (click)="selectAuthDist(associazione_distretto_gravidanza)">
                                <ngx-auth-detail
                                    [nome]="distretto_gravidanza.id + ' - ' + distretto_gravidanza.nome"
                                    [autorizzazione]="associazione_distretto_gravidanza['autorizzazione']"
                                    (onChange)="changeDistrictAuthStatus(associazione_distretto_gravidanza)"
                                >
                                </ngx-auth-detail>
                            </nb-accordion-item-body>
                        </nb-accordion-item>

                        <nb-accordion-item *ngFor="let azienda of aziende">
                            <nb-accordion-item-header>
                                {{azienda.nome}}
                            </nb-accordion-item-header>
                            <nb-accordion-item-body>
                                <nb-list class="container">
                                    <nb-list-item
                                        *ngFor="let ass of getAssDistrettiByAzienda(azienda.id)"
                                        (click)="selectAuthDist(ass)"
                                    >
                                        <ngx-auth-detail
                                            [nome]=" ass['distretto'].nome"
                                            [autorizzazione]="ass['autorizzazione']"
                                            (onChange)="changeDistrictAuthStatus(ass)"
                                        ></ngx-auth-detail>
                                    </nb-list-item>

                                    <nb-list-item *ngIf="distretti?.length">
                                        nessun distretto
                                    </nb-list-item>
                                </nb-list>

                            </nb-accordion-item-body>
                        </nb-accordion-item>

                    </nb-accordion>


                    <nb-card
                        class="col-md-4"
                        *ngIf="current_associazione"
                    >
                        <nb-card-header>Team {{current_associazione["distretto"].nome}} </nb-card-header>
                        <nb-card-body>

                            <nb-list
                                class="container"
                                *ngIf="current_associazione_operatori?.length > 0"
                            >
                                <nb-list-item *ngFor="let ass_op of current_associazione_operatori">
                                    <ngx-auth-detail
                                        [associazione_auth_distretti]="current_associazione"
                                        [nome]="ass_op['team_operatore'].nome"
                                        [ruolo]="ass_op['team_operatore'].role"
                                        [autorizzazione]="ass_op['autorizzazione']"
                                        (onChange)="changeAuthorizationTeamOperatore(ass_op)"
                                    ></ngx-auth-detail>
                                </nb-list-item>
                            </nb-list>
                        </nb-card-body>
                    </nb-card>
                </div>
            </nb-tab>

            <nb-tab
                [nbSpinner]="!autorizzazione_distretti"
                nbSpinnerMessage=""
                tabTitle="AOU"
            >
                <div class="row">
                    <nb-accordion class="col-md-6">
                        <!-- <nb-accordion-item
                        expanded
                        *ngIf="associazione_distretto_gravidanza"
                    >
                        <nb-accordion-item-header>
                            Distretto gravidanza
                        </nb-accordion-item-header>
                        <nb-accordion-item-body (click)="selectAuthDist(associazione_distretto_gravidanza)">
                            <ngx-auth-detail
                                [nome]="distretto_gravidanza.id + ' - ' + distretto_gravidanza.nome"
                                [autorizzazione]="associazione_distretto_gravidanza['autorizzazione']"
                                (onChange)="changeDistrictAuthStatus(associazione_distretto_gravidanza)"
                            >
                            </ngx-auth-detail>
                        </nb-accordion-item-body>
                    </nb-accordion-item> -->

                        <nb-accordion-item *ngFor="let azienda of aziende_universitarie">
                            <nb-accordion-item-header>
                                {{azienda.nome}}
                            </nb-accordion-item-header>
                            <nb-accordion-item-body>
                                <nb-list class="container">
                                    <nb-list-item
                                        *ngFor="let ass of getAssDistrettiByAzienda(azienda.id)"
                                        (click)="selectAuthDist(ass)"
                                    >
                                        <ngx-auth-detail
                                            [nome]=" ass['distretto'].nome"
                                            [autorizzazione]="ass['autorizzazione']"
                                            (onChange)="changeDistrictAuthStatus(ass)"
                                        ></ngx-auth-detail>
                                    </nb-list-item>

                                    <nb-list-item *ngIf="distretti?.length">
                                        nessun distretto
                                    </nb-list-item>
                                </nb-list>

                            </nb-accordion-item-body>
                        </nb-accordion-item>

                    </nb-accordion>


                    <nb-card
                        class="col-md-4"
                        *ngIf="current_associazione"
                    >
                        <nb-card-header>Team {{current_associazione["distretto"].nome}} </nb-card-header>
                        <nb-card-body>

                            <nb-list
                                class="container"
                                *ngIf="current_associazione_operatori?.length > 0"
                            >
                                <nb-list-item *ngFor="let ass_op of current_associazione_operatori">
                                    <ngx-auth-detail
                                        [associazione_auth_distretti]="current_associazione"
                                        [nome]="ass_op['team_operatore'].nome"
                                        [ruolo]="ass_op['team_operatore'].role"
                                        [autorizzazione]="ass_op['autorizzazione']"
                                        (onChange)="changeAuthorizationTeamOperatore(ass_op)"
                                    ></ngx-auth-detail>
                                </nb-list-item>
                            </nb-list>
                        </nb-card-body>
                    </nb-card>
                </div>
            </nb-tab>

            <nb-tab
                [nbSpinner]="!autorizzazione_medici"
                nbSpinnerMessage=""
                tabTitle="Professionisti"
            >

                <nb-card *ngIf="! (autorizzazione_medici?.length)">
                    <nb-card-header>Nessuna autorizzazione da gestire</nb-card-header>
                </nb-card>

                <div
                    *ngIf="autorizzazione_medici?.length"
                    class="row"
                >

                    <nb-card class="col-md-4">
                        <nb-card-header>{{ RuoliUtente.ostetrica | ruoloUtente:true  }}</nb-card-header>
                        <nb-card-body>
                            <nb-list
                                class="container"
                                *ngIf="autorizzazioni_ostetriche?.length"
                            >
                                <nb-list-item *ngFor="let a of autorizzazioni_ostetriche">
                                    <ngx-auth-detail
                                        *ngIf="a "
                                        [nome]=" a?.denominazione"
                                        [dettaglio]="a?.cf_medico"
                                        [autorizzazione]="a"
                                        (onChange)="changeOperatorAuthStatus(a)"
                                    >
                                    </ngx-auth-detail>
                                </nb-list-item>
                            </nb-list>
                            <div *ngIf="! (autorizzazioni_ostetriche?.length)">Nessuna autorizzazione da gestire</div>
                        </nb-card-body>
                    </nb-card>

                    <nb-card class="col-md-4">
                        <nb-card-header>{{ RuoliUtente.medico_ginecologo | ruoloUtente:true }}</nb-card-header>
                        <nb-card-body>
                            <nb-list
                                *ngIf="autorizzazioni_ginecologi?.length"
                                class="container"
                            >
                                <nb-list-item *ngFor="let a of autorizzazioni_ginecologi">
                                    <ngx-auth-detail
                                        [nome]="a?.denominazione"
                                        [dettaglio]="a.cf_medico"
                                        [autorizzazione]="a"
                                        (onChange)="changeOperatorAuthStatus(a)"
                                    ></ngx-auth-detail>

                                </nb-list-item>
                            </nb-list>
                            <div *ngIf="! (autorizzazioni_ginecologi?.length)">Nessuna autorizzazione da gestire</div>
                        </nb-card-body>
                    </nb-card>

                    <nb-card class="col-md-4">
                        <nb-card-header>
                            {{ RuoliUtente.medico_generico | ruoloUtente:true }}
                            <button
                                class="float-right"
                                nbButton
                                (click)="verifica_medico($event)"
                                type="button"
                            >Verifica</button>

                        </nb-card-header>
                        <nb-card-body>
                            <div
                                *ngIf="autorizzazione_medici_generici?.length"
                                class="container"
                            >
                                <div *ngFor="let a of autorizzazione_medici_generici">
                                    <ngx-auth-detail
                                        [nome]="a.denominazione"
                                        [dettaglio]="a.cf_medico"
                                        [autorizzazione]="a"
                                        (onChange)="changeOperatorAuthStatus(a)"
                                    ></ngx-auth-detail>
                                </div>
                            </div>
                            <div *ngIf="! (autorizzazione_medici_generici?.length)">Nessuna autorizzazione da gestire
                            </div>
                        </nb-card-body>
                    </nb-card>
                </div>

            </nb-tab>
        </nb-tabset>
    </nb-card-body>
</nb-card>
